"use client";

import { c as _c } from "react/compiler-runtime";
import { ProgressProvider as Provider } from "@bprogress/next/app";
export const ProgressProvider = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      showSpinner: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Provider height="2px" color="linear-gradient(to right, var(--color-primary), var(--color-secondary))" options={t1} shallowRouting={true}>{children}</Provider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};